import { render } from "./TheGlobalFooter.vue?vue&type=template&id=bbb6a56e&scoped=true&ts=true"
import script from "./TheGlobalFooter.vue?vue&type=script&lang=ts"
export * from "./TheGlobalFooter.vue?vue&type=script&lang=ts"

import "./TheGlobalFooter.vue?vue&type=style&index=0&id=bbb6a56e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbb6a56e"]])

export default __exports__